import styled from '@emotion/styled';

export const EntitlementDetailsHeader = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  > span:first-of-type,
  > img {
    //targeting first span(svg icon) and img of product icon
    height: 60px;
    width: 60px;
  }
  .site-name-link,
  .entitlement-number {
    font-size: 14px;
    font-weight: 400;
  }
`;
